export const data = {
    "questionnaire": {
        "steps": [

            /* ============  step 0 =========== */
            {
                "stepId": "0",
                "stepName": "advisors",
                "stepTitle": "יועצים",
                "waitingTime": "10",
                "numberOfQuestionsMax": "5",
                "questions": [
                    /* ====  qid 0 === */
                    {
                        "questionId": "0",
                        "questionName": "intro",
                        "questionType": "Input",
                        "previousStep": "",
                        "previousQuestion": "",
                        "previousAnswer": "",
                        "questionText": "פתיח",
                        "CRMFlag": "concat",
                        "CRM": [{ "q": "אני יועץ", "order": 0 }],
                        "questionWithMultipleAnswers": false,
                        "answer": {
                            "nextStep": "0",
                            "nextQuestion": "1",
                            "fields": [
                            ]
                        }
                    },
                    /* ====  qid 1 === */
                    {
                        "questionId": "1",
                        "questionName": "whatsYourIdentityNumber",
                        "questionType": "Input",
                        "previousStep": "0",
                        "previousQuestion": "0",
                        "previousAnswer": "0",
                        "questionText": "ת.ז",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "?יועץ מה מספר תעודת הזהות שלך", "order": 0.2 }],
                        "answer": {
                            "nextStep": "0",
                            "nextQuestion": "2",
                            "fields": [
                                {
                                    "answerText": "ת.ז",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    /* ====  qid 2 === */
                    {
                        "questionId": "2",
                        "questionName": "whatsYourName",
                        "questionType": "Input",
                        "previousStep": "0",
                        "previousQuestion": "1",
                        "previousAnswer": "1",
                        "questionText": "?איך קוראים לך",
                        "CRMFlag": "concat",
                        "CRM": [{ "q": "?יועץ איך קוראים לך", "order": 0.1 }],
                        "questionWithMultipleAnswers": false,
                        "answer": {
                            "nextStep": "0",
                            "nextQuestion": "3",
                            "fields": [
                                {
                                    "answerText": "שם פרטי",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "שם משפחה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },

                    /* ====  qid 3 === */
                    {
                        "questionId": "3",
                        "questionName": "whatsYourTel",
                        "questionType": "Input",
                        "previousStep": "0",
                        "previousQuestion": "2",
                        "previousAnswer": "1",
                        "questionText": "?מה מספר הטלפון שלך",
                        "CRM": [{ "q": "?יועץ מה מספר הטלפון שלך", "order": 0.3 }],
                        "questionWithMultipleAnswers": false,
                        "answer": {
                            "nextStep": "0",
                            "nextQuestion": "4",
                            "fields": [
                                // {
                                //     "answerTextPrefix": "בחר קידומת",
                                //     "answerValue": ""
                                // },
                                {
                                    "answerText": "טלפון",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    /* ====  qid 4 === */
                    {
                        "questionId": "4",
                        "questionName": "whatsYourConsultingCompany",
                        "questionType": "Input",
                        "previousStep": "0",
                        "previousQuestion": "3",
                        "previousAnswer": "1",
                        "questionText": "מהי חברת הייעוץ שמעסיקה אותך?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "?יועץ מהי חברת הייעוץ שמעסיקה אותך", "order": 0.5 }],
                        "answer": {
                            "nextStep": "0",
                            "nextQuestion": "5",
                            "fields": [
                                {
                                    "answerText": "חברת ייעוץ",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    /* ====  qid 5 === */
                    {
                        "questionId": "5",
                        "questionName": "tz",
                        "questionType": "Input",
                        "previousStep": "",
                        "previousQuestion": "",
                        "previousAnswer": "",
                        "questionText": "ת.ז לקוח",
                        "CRMFlag": "concat",
                        "questionWithMultipleAnswers": false,
                        "answer": {
                            "nextStep": "1",
                            "nextQuestion": "1",
                            "fields": [
                                {
                                    "answerText": "ת.ז",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                ]
            },

            /* ============  step 1 =========== */
            {
                "stepId": "1",
                "stepName": "user-details",
                "stepTitle": "התחלה",
                "waitingTime": "10",
                "numberOfQuestionsMax": "7",
                "questions": [
                    /* ====  qid 1 === */
                    {
                        "questionId": "1",
                        "questionName": "whatsYourName",
                        "questionType": "Input",
                        "previousStep": "",
                        "previousQuestion": "",
                        "previousAnswer": "",
                        "questionText": "איך קוראים לך",
                        "CRMFlag": "concat",
                        "CRM": [{ "q": "איך קוראים לך", "order": 1 }],
                        "questionWithMultipleAnswers": false,
                        "answer": {
                            "nextStep": "1",
                            "nextQuestion": "2",
                            "fields": [
                                {
                                    "answerText": "שם פרטי",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "שם משפחה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    /* ====  qid 2 === */
                    {
                        "questionId": "2",
                        "questionName": "whatsYourIdentityNumber",
                        "questionType": "Input",
                        "previousStep": "1",
                        "previousQuestion": "1",
                        "previousAnswer": "1",
                        "questionText": "ת.ז",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה מספר תעודת הזהות שלך?", "order": 2 }],
                        "answer": {
                            "nextStep": "1",
                            "nextQuestion": "3",
                            "fields": [
                                {
                                    "answerText": "ת.ז",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    /* ====  qid 3 === */
                    {
                        "questionId": "3",
                        "questionName": "whatsYourBirthDate",
                        "questionType": "Input",
                        "previousStep": "1",
                        "previousQuestion": "2",
                        "previousAnswer": "1",
                        "questionText": "מה תאריך הלידה שלך?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה תאריך הלידה שלך?", "order": 3 }],
                        "answer": {
                            "nextStep": "1",
                            "nextQuestion": "4",
                            "fields": [
                                {
                                    "answerText": "תאריך לידה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    /* ====  qid 4 === */
                    {
                        "questionId": "4",
                        "questionName": "whatsYourTel",
                        "questionType": "Input",
                        "previousStep": "1",
                        "previousQuestion": "3",
                        "previousAnswer": "1",
                        "questionText": "מה מספר הטלפון שלך?",
                        "CRM": [{ "q": "מה מספר הטלפון שלך?", "order": 4 }],
                        "questionWithMultipleAnswers": false,
                        "answer": {
                            "nextStep": "1",
                            "nextQuestion": "4.5",
                            "fields": [
                                {
                                    "answerText": "טלפון",
                                    "answerValue": ""
                                }
                            ]
                        },
                    },
                    /* ====  qid 4.5 === */
                    {
                        "questionId": "4.5",
                        "questionName": "whatsYourEmail",
                        "questionType": "Input",
                        "previousStep": "1",
                        "previousQuestion": "4",
                        "previousAnswer": "1",
                        "questionText": "מה הדואל שלך",
                        "CRM": [{ "q": "מה הדואל שלך", "order": 5 }],
                        "questionWithMultipleAnswers": false,
                        "answer": {
                            "nextStep": "1",
                            "nextQuestion": "5",
                            "fields": [
                                {
                                    "answerText": "הדואל",
                                    "answerValue": ""
                                }
                            ]
                        },
                    },
                    /* ====  qid 5 === */
                    {
                        "questionId": "5",
                        "questionName": "whatsYourMStatus",
                        "questionType": "Input",
                        "previousStep": "1",
                        "previousQuestion": "4",
                        "previousAnswer": "1",
                        "questionText": "מה מצבך המשפחתי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה מצבך המשפחתי?", "order": 5 }],
                        "answer": {
                            "nextStep": "1",
                            "nextQuestion": "6",
                            "fields": [
                                {
                                    "answerText": "מצב משפחתי",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    /* ====  qid 6 === */
                    {
                        "questionId": "6",
                        "questionName": "additionalBorrowers",
                        "questionType": "YesNo",
                        "previousStep": "1",
                        "previousQuestion": "5",
                        "previousAnswer": "1",
                        "questionText": "האם יש לווים נוספים?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "האם יש לווים נוספים?", "order": 6 }],
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "nextStep": "1",
                                "nextQuestion": "7",
                                "answerText": "כן"

                            },
                            "NO":
                            {
                                "answerId": "2",
                                "nextStep": "2",
                                "nextQuestion": "1",
                                "answerText": "לא"

                            }
                        }
                    },
                    {
                        "questionId": "6.1",
                        "questionName": "agreeEmail",
                        "questionType": "YesNo",
                        "previousStep": "1",
                        "previousQuestion": "1",
                        "previousAnswer": "1",
                        "questionText": "מסכים לדיור",
                        "questionWithMultipleAnswers": true,
                        "CRM": [{ "q": "מסכים לדיור", "order": 6.1 }],
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "answerText": "כן"

                            },
                            "NO":
                            {
                                "answerId": "2",
                                "answerText": "לא"
                            }
                        }
                    },
                    /* ====  qid 7 === */
                    {
                        "questionId": "7",
                        "questionName": "additionalBorrowersDetails1",
                        "isJunction": false,
                        "nextIfHasBorrower": true,
                        "questionType": "Borrower",
                        "previousStep": "1",
                        "previousQuestion": "6",
                        "previousAnswer": "1",
                        "questionText": " פרטי הלווים הנוספים",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "נא להשלים את פרטי הלווה הנוסף. שם לווה", "order": 41 },
                        { "q": "טלפון לווה", "order": 43 },
                        { "q": "תאריך לידה לווה", "order": 45 },
                        { "q": "תז. לווה", "order": 42 },
                        { "q": "קרבה הלווה", "order": 44 },
                        { "q": "אימייל הלווה", "order": 46 }],
                        "answer": {
                            "nextStep": "2",
                            "nextQuestion": "1",
                            "answer-data": [
                                {
                                    borrowerId: "1",
                                    "fields": [
                                        {
                                            "answerText": "נא להשלים את פרטי הלווה הנוסף. שם לווה",
                                            "answerKey": "borrowerFullName",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "טלפון לווה",
                                            "answerKey": "borrowerPhoneNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "תאריך לידה לווה",
                                            "answerKey": "borrowerBirthDate",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "תז. לווה",
                                            "answerKey": "borrowerIdNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "קרבה הלווה",
                                            "answerKey": "borrowerProximity",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "אימייל הלווה",
                                            "answerKey": "borrowerEmail",
                                            "answerValue": ""
                                        }
                                    ]
                                },
                                {
                                    borrowerId: "2",
                                    "fields": [
                                        {
                                            "answerText": "נא להשלים את פרטי הלווה הנוסף. שם לווה",
                                            "answerKey": "borrowerFullName",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "טלפון לווה",
                                            "answerKey": "borrowerPhoneNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "תאריך לידה לווה",
                                            "answerKey": "borrowerBirthDate",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "תז. לווה",
                                            "answerKey": "borrowerIdNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "קרבה הלווה",
                                            "answerKey": "borrowerProximity",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "אימייל הלווה",
                                            "answerKey": "borrowerEmail",
                                            "answerValue": ""
                                        }
                                    ]
                                },
                                {
                                    borrowerId: "3",
                                    "fields": [
                                        {
                                            "answerText": "נא להשלים את פרטי הלווה הנוסף. שם לווה",
                                            "answerKey": "borrowerFullName",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "טלפון לווה",
                                            "answerKey": "borrowerPhoneNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "תאריך לידה לווה",
                                            "answerKey": "borrowerBirthDate",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "תז. לווה",
                                            "answerKey": "borrowerIdNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "קרבה הלווה",
                                            "answerKey": "borrowerProximity",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "אימייל הלווה",
                                            "answerKey": "borrowerEmail",
                                            "answerValue": ""
                                        }
                                    ]
                                },
                                {
                                    borrowerId: "4",
                                    "fields": [
                                        {
                                            "answerText": "נא להשלים את פרטי הלווה הנוסף. שם לווה",
                                            "answerKey": "borrowerFullName",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "טלפון לווה",
                                            "answerKey": "borrowerPhoneNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "תאריך לידה לווה",
                                            "answerKey": "borrowerBirthDate",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "תז. לווה",
                                            "answerKey": "borrowerIdNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "קרבה הלווה",
                                            "answerKey": "borrowerProximity",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "אימייל הלווה",
                                            "answerKey": "borrowerEmail",
                                            "answerValue": ""
                                        }
                                    ]
                                },
                                {
                                    borrowerId: "5",
                                    "fields": [
                                        {
                                            "answerText": "נא להשלים את פרטי הלווה הנוסף. שם לווה",
                                            "answerKey": "borrowerFullName",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "טלפון לווה",
                                            "answerKey": "borrowerPhoneNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "תאריך לידה לווה",
                                            "answerKey": "borrowerBirthDate",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "תז. לווה",
                                            "answerKey": "borrowerIdNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "קרבה הלווה",
                                            "answerKey": "borrowerProximity",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "אימייל הלווה",
                                            "answerKey": "borrowerEmail",
                                            "answerValue": ""
                                        }
                                    ]
                                }
                            ]

                        }
                    },
                ]
            },


            /* ============  step 2 =========== */
            {
                "stepId": "2",
                "stepName": "loan-details",
                "stepTitle": "פרטי ההלוואה",
                "waitingTime": "10",
                "numberOfQuestionsMax": "7",
                "questions": [
                    /* ====  qid 1 === */
                    {
                        "questionId": "1",
                        "isJunction": true,
                        "questionName": "WhatsThePurpose",
                        "questionType": "YesNo",
                        "previousStep": "1",
                        "previousQuestion": "",
                        "previousAnswer": "",
                        "questionText": "מה מטרת ההלוואה",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 8,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "1":
                            {
                                "answerId": "1",
                                "nextStep": "2",
                                "nextQuestion": "2",
                                "answerText": "קניית דירה מקבלן"
                            },
                            "2":
                            {
                                "answerId": "2",
                                "nextStep": "2",
                                "nextQuestion": "2",
                                "answerText": "קניית דירה יד שניה"
                            },
                            "5":
                            {
                                "answerId": "3",
                                "nextStep": "2",
                                "nextQuestion": "2",
                                "answerText": "בניה עצמית"
                            },
                            "10":
                            {
                                "answerId": "4",
                                "nextStep": "2",
                                "nextQuestion": "2",
                                "answerText": "קניית מגרש"
                            },
                            "7":
                            {
                                "answerId": "5",
                                "nextStep": "2",
                                "nextQuestion": "2",
                                "answerText": "הרחבה",
                            },
                            "11":
                            {
                                "answerId": "6",
                                "nextStep": "2",
                                "nextQuestion": "1.1",
                                "answerText": "הלוואה לכל מטרה"
                            },
                            "17":
                            {
                                "answerId": "7",
                                "nextStep": "2",
                                "nextQuestion": "2",
                                "answerText": "שיפוצים",
                            }
                        }
                    },
                    /* ====  qid 1.1 === */
                    {
                        "questionId": "1.1",
                        "questionName": "loanPurposeDetails",
                        "questionType": "Input",
                        "previousStep": "2",
                        "previousQuestion": "1",
                        "previousAnswer": "6",
                        "questionText": "למה מיועדים כספי ההלוואה",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "למה מיועדים כספי ההלוואה", "order": 81 }],
                        "answer": {
                            "nextStep": "2",
                            "nextQuestion": "2",
                            "fields": [
                                {
                                    "answerText": "מטרת ההלוואה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    /* ====  qid 2 === */
                    {
                        "questionId": "2",
                        "isJunction": true,
                        "questionName": "howMuchYouNeed",
                        "questionType": "Input",
                        "previousStep": "2",
                        "previousQuestion": "1",
                        "previousAnswer": "",
                        "questionText": "מה סכום ההלוואה שאתה צריך?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": " מה סכום ההלוואה שאתה צריך?", "order": 9 }],
                        "answer": {
                            "nextStep": "2",
                            "nextQuestion": "2.0",
                            "fields": [
                                {
                                    "answerText": "סכום ההלוואה שאתה צריך",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },

                    /* ====  qid 2.0 === */
                    {
                        "questionId": "2.0",
                        "isJunction": true,
                        "questionName": "haveOneYet",
                        "questionType": "YesNo",
                        "previousStep": "2",
                        "previousQuestion": "2",
                        "previousAnswer": "1",
                        "questionText": "האם יש לך תעודת זכאות ממשרד הבינוי והשיכון?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 10,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "nextStep": "2",
                                "nextQuestion": "2.1",
                                "answerText": "כן"

                            },
                            "NO":
                            {
                                "answerId": "2",
                                "nextStep": "2",
                                "nextQuestion": "2.2",
                                "answerText": "לא"

                            }
                        }
                    },
                    /* ====  qid 2.1 === */
                    {
                        "questionId": "2.1",
                        "isJunction": true,
                        "questionName": "howMuchYouNeed",
                        "questionType": "Input",
                        "previousStep": "2",
                        "previousQuestion": "2.0",
                        "previousAnswer": "",
                        "questionText": "מהו סכום הלוואת הזכאות המגיע לך?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": " מהו סכום הלוואת הזכאות המגיע לך?", "order": 9 }],
                        "answer": {
                            "nextStep": "2",
                            "nextQuestion": "2.2",
                            "fields": [
                                {
                                    "answerText": "סכום הלוואת הזכאות המגיע לך",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },

                    /* ====  qid 2.2 === */
                    {
                        "questionId": "2.2",
                        "isJunction": true,
                        "questionName": "howMuchYouNeed",
                        "questionType": "Input",
                        "previousStep": "2",
                        "previousQuestion": "2",
                        "previousAnswer": "",
                        "questionText": "לכמה שנים ברצונך לפרוס את החזר המשכנתא?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": " לכמה שנים ברצונך לפרוס את החזר המשכנתא?", "order": 9 }],
                        "answer": {
                            "nextStep": "2",
                            "nextQuestion": "2.4",
                            "fields": [
                                {
                                    "answerText": "לכמה שנים ברצונך לפרוס את החזר המשכנתא",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },

                    /* ====  qid 2.3 === */
                    {
                        "questionId": "2.3",
                        "isJunction": false,
                        "questionName": "haveOneYet",
                        "questionType": "YesNo",
                        "previousStep": "2",
                        "previousQuestion": "2.2",
                        "previousAnswer": "1",
                        "questionText": "האם תמהיל גנרי?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 10,
                        "selectedAnswer": "1",
                        "answersOptions": {
                            "1":
                            {
                                "answerId": "1",
                                "nextStep": "2",
                                "nextQuestion": "3",
                                "answerText": "הרכב גנרי"

                            },
                            "2":
                            {
                                "answerId": "2",
                                "nextStep": "2",
                                "nextQuestion": "3",
                                "answerText": "תמהיל עצמאי"

                            }
                        }
                    },
                    /* ==== advisor === */
                    {
                        "questionId": "2.4",
                        "questionName": "Mixture",
                        "questionType": "InputArray",
                        "previousStep": "2",
                        "previousQuestion": "2.3",
                        "previousAnswer": "",
                        "questionText": "תמהיל מבוקש",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "סוג מסלול", "order": 9.1 },
                        { "q": "סכום מבוקש של המסלול", "order": 9.2 },
                        { "q": "תקופה של המסלול", "order": 9.3 },
                        { "q": "ריבית של המסלול", "order": 9.4 }],
                        "answer": {
                            "nextStep": "2",
                            "nextQuestion": "3",
                            "fieldsArray": [
                                [{
                                    "answerText": "סוג מסלול",
                                    "answerKey": "type",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "סכום מבוקש",
                                    "answerKey": "amount",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "תקופה",
                                    "answerKey": "period",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "ריבית",
                                    "answerKey": "ribit",
                                    "answerValue": ""
                                }]
                            ]
                        }
                    },
                    /* ====  qid 3 === */
                    {
                        "questionId": "3",
                        "isJunction": true,
                        "questionName": "haveOneYet",
                        "questionType": "YesNo",
                        "previousStep": "2",
                        "previousQuestion": "2",
                        "previousAnswer": "1",
                        "questionText": "האם בבעלותך דירה או חלק מדירה?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 10,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "nextStep": "2",
                                "nextQuestion": "4",
                                "answerText": "כן"

                            },
                            "NO":
                            {
                                "answerId": "2",
                                "nextStep": "2",
                                "nextQuestion": "6",
                                "answerText": "לא"

                            }
                        }
                    },
                    /* ====  qid 4 === */
                    {
                        "questionId": "4",
                        "isJunction": true,
                        "questionName": "forThePropertyYouOwn",
                        "questionType": "YesNo",//??
                        "previousStep": "2",
                        "previousQuestion": "3",
                        "previousAnswer": "1",
                        "questionText": "האם ההלוואה היא כנגד הנכס שכבר בבעלותך או כנגד הנכס שאתה מבקש לרכוש?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 74,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "nextStep": "2",
                                "nextQuestion": "5",
                                "answerText": "ההלוואה כנגד הנכס בבעלותך",
                            },
                            "NO":
                            {
                                "answerId": "2",
                                "nextStep": "2",
                                "nextQuestion": "5",
                                "answerText": "ההלוואה כנגד הנכס שאתה מבקש לרכוש",
                            }
                        }
                    },
                    /* ====  qid 5 === */
                    {
                        "questionId": "5",
                        "questionName": "doYouIntendToSellIt",
                        "questionType": "YesNo",
                        "previousStep": "2",
                        "previousQuestion": "4",
                        "previousAnswer": "",
                        "questionText": "האם בכוונתך למכור את הדירה?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 11,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "nextStep": "3",
                                "nextQuestion": "1",
                                "answerText": "כן בכוונתך למכור את הדירה"

                            },
                            "NO":
                            {
                                "answerId": "2",
                                "nextStep": "3",
                                "nextQuestion": "1",
                                "answerText": "לא בכוונתך למכור את הדירה"

                            }
                        }
                    },
                    /* ====  qid 6 === */
                    {
                        "questionId": "6",
                        "questionName": "itsMehirLemishtaken",
                        "questionType": "YesNo",
                        "previousStep": "2",
                        "previousQuestion": "",
                        "previousAnswer": "",
                        "questionText": "בדירה פרויקט למשתכן",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 12,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "nextStep": "2",
                                "nextQuestion": "7",
                                "answerText": "כן"

                            },
                            "NO":
                            {
                                "answerId": "2",
                                "nextStep": "3",
                                "nextQuestion": "1",
                                "answerText": "לא"

                            }
                        }
                    },
                    /* ====  qid 7 === */
                    {
                        "questionId": "7",
                        "questionName": "whatsTheValue ",
                        "questionType": "Input",
                        "previousStep": "2",
                        "previousQuestion": "6",
                        "previousAnswer": "1",
                        "questionText": " שווי הנכס? עלות בחוזה?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "שווי הנכס? עלות בחוזה?", "order": 13 }],
                        "CRMFlag": "concat",
                        "answer": {
                            "nextStep": "3",
                            "nextQuestion": "1",
                            "fields": [
                                {
                                    "answerText": "שווי הנכס בשוק",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "עלות הדירה בחוזה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    }
                ]
            },


            /* ============  step 3 =========== */
            {
                "stepId": "3",
                "stepName": "property-details",
                "stepTitle": "פרטי הנכס",
                "waitingTime": "10",
                "numberOfQuestionsMax": "5",
                "questions": [
                    {
                        "questionId": "1",
                        "questionName": "inWhichCity",
                        "questionType": "Input",
                        "previousStep": "2",
                        "previousQuestion": "7",
                        "previousAnswer": "",
                        "questionText": "באיזו עיר נמצא הנכס?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "באיזו עיר נמצא הנכס?", "order": 14 }],
                        "answer": {
                            "nextStep": "3",
                            "nextQuestion": "2",
                            "fields": [
                                {
                                    "answerText": "באיזו עיר הנכס ",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "2",
                        "questionName": "whatsTheValueOfTheProperty",
                        "questionType": "Input",
                        "previousStep": "3",
                        "previousQuestion": "1",
                        "previousAnswer": "1",
                        "questionText": "מה שווי הנכס?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה שווי הנכס?", "order": 15 }],
                        "answer": {
                            "nextStep": "3",
                            "nextQuestion": "5",
                            "fields": [
                                {
                                    "answerText": "שווי הנכס",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "3",
                        "questionName": "valueOfStadium&AmountOfConstructionCosts",
                        "questionType": "Input",
                        "previousStep": "3",
                        "previousQuestion": "2",
                        "previousAnswer": "1",
                        "questionText": "שווי מגרש וסכום עלויות הבניה",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "שווי מגרש", "order": 16 }, { "q": "סכום עלויות הבניה", "order": 22 }],
                        "answer": {
                            "nextStep": "3",
                            "nextQuestion": "3.1",
                            "fields": [
                                {
                                    "answerText": "שווי המגרש",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "סכום עליות הבנייה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "3.1",
                        "questionName": "isYourProperty",
                        "questionType": "YesNo",
                        "previousStep": "3",
                        "previousQuestion": "3",
                        "previousAnswer": "",
                        "questionText": "האם המגרש בבעלותך ?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 91,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "nextStep": "3",
                                "nextQuestion": "4",
                                "answerText": "כן"
                            },
                            "NO":
                            {
                                "answerId": "2",
                                "nextStep": "3",
                                "nextQuestion": "4",
                                "answerText": "לא"
                            }
                        }
                    },
                    {
                        "questionId": "3.2",
                        "questionName": "planToBuildOnTheField",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "3",
                        "previousQuestion": "2",
                        "previousAnswer": "",
                        "questionText": "האם בכוונתך לבנות על המגרש ?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 92,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "nextStep": "3",
                                "nextQuestion": "3.3",
                                "answerText": "כן"
                            },
                            "NO":
                            {
                                "answerId": "2",
                                "nextStep": "3",
                                "nextQuestion": "5",
                                "answerText": "לא"
                            }
                        }
                    },
                    {
                        "questionId": "3.3",
                        "questionName": "expectedConstructionCost",
                        "questionType": "Input",
                        "previousStep": "3",
                        "previousQuestion": "3.2",
                        "previousAnswer": "1",
                        "questionText": "מהי עלות הבנייה הצפוייה?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מהי עלות הבנייה הצפוייה?", "order": 93 }],
                        "answer": {
                            "nextStep": "3",
                            "nextQuestion": "5",
                            "fields": [
                                {
                                    "answerText": "עלות הבנייה הצפוייה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "4",
                        "questionName": "propertyAlreadyMortgaged",
                        "questionType": "YesNo",
                        "previousStep": "3",
                        "previousQuestion": "",
                        "previousAnswer": "",
                        "questionText": "האם הנכס כבר משועבד?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 66,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "nextStep": "3",
                                "nextQuestion": "5",
                                "answerText": "כן"
                            },
                            "NO":
                            {
                                "answerId": "2",
                                "nextStep": "3",
                                "nextQuestion": "5",
                                "answerText": "לא"
                            }
                        }
                    },
                    {
                        "questionId": "5",
                        "questionName": "haveYouAlreadySigned",
                        "questionType": "YesNo",
                        "previousStep": "3",
                        "previousQuestion": "",
                        "previousAnswer": "",
                        "questionText": "נחתם חוזה על הדירה?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 79,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "nextStep": "3",
                                "nextQuestion": "6",
                                "answerText": "כן"

                            },
                            "NO":
                            {
                                "answerId": "2",
                                "nextStep": "3",
                                "nextQuestion": "6",
                                "answerText": "לא"

                            }
                        }
                    },

                    {
                        "questionId": "6",
                        "questionName": "timeForMortgageMoney",
                        "questionType": "Input",
                        "previousStep": "3",
                        "previousQuestion": "5",
                        "previousAnswer": "",
                        "questionText": "תוך כמה זמן יש להעביר לחשבונך את כספי המשכנתה?",
                        "CRM": [{ "q": "תוך כמה זמן יש להעביר לחשבונך את כספי המשכנתה?", "order": 80 }],
                        "questionWithMultipleAnswers": false,
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "1",
                            "fields": [
                                {
                                    "answerText": "זמן",
                                    "answerValue": ""
                                }
                            ]
                        }
                    }
                ]
            },

            /* ============  step 4 =========== */
            {
                "stepId": "4",
                "stepName": "borrowers-details",
                "stepTitle": "פרטי הלווים",
                "waitingTime": "10",
                "numberOfQuestionsMax": "31",
                "questions": [
                    {
                        "questionId": "1",
                        "questionName": "mainBorrowerDetails",
                        "isJunction": true,
                        "questionType": "Input",
                        "previousStep": "3",
                        "previousQuestion": "5",
                        "previousAnswer": "",
                        "questionText": "מספר פרטים נוספים",
                        "questionWithMultipleAnswers": false,
                        "CRM": [
                            // {"q":"מה כתובת המגורים?", "order":21},
                            // {"q":" מה תאריך הלידה?", "order":17},
                            { "q": "כמה ילדים יש בבית מתחת לגיל 18?", "order": 19 },
                            // {"q":" מה מצבך המשפחתי?", "order":18},
                            { "q": " מקום מגוריך הנוכחי?", "order": 82 },
                            // {"q":" מה כתובת המייל?", "order":95}
                        ],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "5",
                            "fields": [
                                // {
                                //     "answerText": "כתובת מגורים",
                                //     "answerValue": ""
                                // },
                                // {
                                //     "answerText": "תאריך לידה",
                                //     "answerValue": ""
                                // },
                                {
                                    "answerText": "מספר ילדים",
                                    "answerValue": ""
                                },
                                // {
                                //     "answerText": "מצב משפחתי",
                                //     "answerValue": ""
                                // },
                                {
                                    "answerText": "מקום מגוריך הנוכחי",
                                    "answerValue": ""
                                }/*,
                                {
                                    "answerText": "כתובת מייל",
                                    "answerValue": ""
                                }*/
                            ]
                        }
                    },
                    {
                        "questionId": "4.1",
                        "questionName": "payMezonot",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "4",
                        "previousQuestion": "1",
                        "previousAnswer": "",
                        "questionText": "האם אתה משלם מזונות?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 83,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "5",
                                "answerText": "כן"

                            },
                            "NO":
                            {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "5",
                                "answerText": "לא"

                            }
                        }
                    },
                    {
                        "questionId": "5",
                        "questionName": "Profession&Education",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "1",
                        "previousAnswer": "1",
                        "questionText": "מה השכלתך? מהו מקצועתך?",
                        "CRM": [{ "q": "מה השכלתך?", "order": 20 }, { "q": "מהו מקצועתך?", "order": 26 }],
                        "questionWithMultipleAnswers": false,
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "7",
                            "fields": [
                                {
                                    "answerText": "השכלה",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מקצוע",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "7",
                        "questionName": "statusEmployment",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "4",
                        "previousQuestion": "5",
                        "previousAnswer": "1",
                        "questionText": "באיזה אופן אתה מועסק?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 23,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "employee":
                            {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "8a",
                                "answerText": "שכיר"
                            },
                            "independent":
                            {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "7.1",
                                "answerText": "עצמאי"
                            },
                            "unemployed":
                            {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "20",
                                "answerText": "לא עובד"
                            },
                            "employeeAndIndependent":
                            {
                                "answerId": "4",
                                "nextStep": "4",
                                "nextQuestion": "14",
                                "answerText": "גם עצמאי וגם שכיר"
                            }
                        }
                    },
                    {
                        "questionId": "7.1",
                        "questionName": "yeshuvAvodaForIndependent",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "7",
                        "previousAnswer": "",
                        "questionText": "באיזה יישוב אתה עובד כעצמאי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "באיזה יישוב אתה עובד כעצמאי?", "order": 14 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "8b",
                            "fields": [
                                {
                                    "answerText": "באיזו עיר ",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "8a",
                        "questionName": "startOfWorkDate",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "4",
                        "previousQuestion": "7",
                        "previousAnswer": "",
                        "questionText": "שנות ותק אצל המעסיק הנוכחי",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 24,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "under1": {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "9a",
                                "answerText": "מתחת לשנה"
                            },
                            "over1": {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "10",
                                "answerText": "יותר משנה"
                            },
                            "over3": {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "10",
                                "answerText": "יותר מ3 שנים"
                            }
                        }
                    },
                    {
                        "questionId": "8b",
                        "questionName": "startOfWorkDate",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "4",
                        "previousQuestion": "7",
                        "previousAnswer": "",
                        "questionText": "שנות ותק כעצמאי",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 24,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "under1": {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "9b",
                                "answerText": "מתחת לשנה"
                            },
                            "over1": {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "13",
                                "answerText": "יותר משנה"
                            },
                            "over3": {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "13",
                                "answerText": "יותר מ3 שנים"
                            }
                        }
                    },
                    {
                        "questionId": "9a",
                        "questionName": "howLongWorkedPreviousWorkplace",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "8a",
                        "previousAnswer": "1",
                        "questionText": "כמה זמן עבדת במקום העבודה הקודם שלך?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "כמה זמן עבדת במקום העבודה הקודם שלך?", "order": 25 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "10",
                            "fields": [
                                {
                                    "answerText": "זמן במקום העבודה הקודם",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "9b",
                        "questionName": "howLongWorkedPreviousWorkplace",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "8b",
                        "previousAnswer": "1",
                        "questionText": "כמה זמן עבדת במקום העבודה הקודם שלך?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "כמה זמן עבדת במקום העבודה הקודם שלך?", "order": 25 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "13",
                            "fields": [
                                {
                                    "answerText": "זמן במקום העבודה הקודם",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "10",
                        "questionName": "whatsYourMonthlyIncome",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "",
                        "previousAnswer": "",
                        "questionText": "מה סכום ההכנסה החודשי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה סכום ההכנסה החודשי?", "order": 27 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "11",
                            "fields": [
                                {
                                    "answerText": "הכנסה החודשית",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "11",
                        "questionName": "nameAndFieldOccupation",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "10",
                        "previousAnswer": "1",
                        "questionText": "שם הארגון בו אתה מועסק וסיווג הארגון ומקום עבודה",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה שם הארגון בו אתה מועסק?", "order": 28 }, { "q": "מה סיווג הארגון בו אתה עובד?", "order": 29.5 }, { "q": "מקום עבודה בו אתה עובד?", "order": 29.8 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "20",
                            "fields": [
                                {
                                    "answerText": "שם הארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סיווג ארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מקום עבודה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "13",
                        "questionName": "annualIncome",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "",
                        "previousAnswer": "",
                        "questionText": "מה סכום ההכנסה השנתית?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה סכום ההכנסה השנתית?", "order": 30 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "20",
                            "fields": [
                                {
                                    "answerText": "הכנסה השנתית",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "14",
                        "questionName": "startedDate&MonthlyIncomeAsEmployee",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "7",
                        "previousAnswer": "4",
                        "questionText": " תאריך תחילת עבודה כשכיר וסכום ההכנסה החודשי נטו מעבודתך כשכיר",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מתי התחלת לעבוד כשכיר?", "order": 31 }, { "q": "סכום ההכנסה החודשי נטו כשכיר", "order": 32 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "16",
                            "fields": [
                                {
                                    "answerText": "תחילת עבודה כשכיר",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "סכום ההכנסה החודשי נטו כשכיר",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "16",
                        "questionName": "nameAndFieldOccupationForEmployeeAndIndependent",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "14",
                        "previousAnswer": "1",
                        "questionText": " מה שם הארגון, תחום העיסוק של הארגון בו אתה עובד וסיווג הארגון?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה שם הארגון בו אתה מועסק?", "order": 28 }, { "q": "מה סיווג הארגון בו אתה עובד?", "order": 29.5 }, { "q": "מקום עבודה בו אתה עובד?", "order": 29.8 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "18",
                            "fields": [
                                {
                                    "answerText": "שם הארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סיווג ארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מקום עבודה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "18",
                        "questionName": "startedDate&AnnualIncomeAsIndependent",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "16",
                        "previousAnswer": "1",
                        "questionText": "תאריך תחילת עבודה כעצמאי + סכום ההכנסה השנתית נטו כעצמאי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "תחילת העבודה של כעצמאי", "order": 35 }, { "q": "מהי  ההכנסה השנתית נטו כעצמאי?", "order": 36 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "20",
                            "fields": [
                                {
                                    "answerText": "תאריך תחילת עבודה כעצמאי",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הכנסה השנתית נטו כעצמאי",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "20",
                        "questionName": "additionalIncomeType&AmountMonthly",
                        "questionType": "InputArray",
                        "previousStep": "4",
                        "previousQuestion": "",
                        "previousAnswer": "",
                        "questionText": " האם יש לך הכנסות נוספות ומה סכום ההכנסה החודשי נטו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "האם יש לך הכנסות נוספות?מה סוג ההכנסה? (המשך)", "order": 37 },
                        { "q": "מה סכום ההכנסה החודשי נטו?", "order": 39 },
                        { "q": "פירוט ההכנסה", "order": 84 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "29",
                            "fieldsArray": [
                                [{
                                    "answerText": " סוג הכנסה נוספת",
                                    "answerKey": "type",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "סכום ההכנסה החודשי",
                                    "answerKey": "amount",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "פירוט ההכנסה",
                                    "answerKey": "source",
                                    "answerValue": ""
                                }]
                            ]
                        }
                    },
                    {
                        "questionId": "20.1",
                        "questionName": "startOfWorkDate",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "4",
                        "previousQuestion": "20",
                        "previousAnswer": "",
                        "questionText": "שנות ותק",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 24,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "under": {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "29",
                                "answerText": "מתחת לשנה"
                            },
                            "middle": {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "29",
                                "answerText": "יותר משנה"
                            },
                            "over": {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "29",
                                "answerText": "יותר מ3 שנים"
                            }
                        }
                    },
                    // {
                    //     "questionId": "22",
                    // 	"questionName": "additionalBorrowers",
                    //     "isJunction": true,						
                    //     "questionType": "YesNo",
                    //     "previousStep": "4",
                    //     "previousQuestion": "20",
                    //     "previousAnswer": "1",
                    //     "questionText": " האם יש לווים נוספים?",
                    //     "questionWithMultipleAnswers": true,
                    //     "CRMOrder":40,
                    //     "selectedAnswer": "",
                    //     "answersOptions": {
                    //         "YES":
                    //             {
                    //                 "answerId": "1",
                    //                 "nextStep": "4",
                    //                 "nextQuestion": "23",
                    //                 "answerText": "כן"

                    //             },
                    //         "NO":
                    //             {
                    //                 "answerId": "2",
                    //                 "nextStep": "5",
                    //                 "nextQuestion": "4",
                    //                 "answerText": "לא"

                    //             }
                    //     }
                    // },
                    // {   "questionId": "23",
                    //     "questionName": "additionalBorrowersDetails1",
                    //     "isJunction": true,		
                    //     "nextIfHasBorrower": true,
                    //     "questionType": "Borrower",
                    //     "previousStep": "4",
                    //     "previousQuestion": "22",
                    //     "previousAnswer": "1",
                    //     "questionText": " פרטי הלווים הנוספים",
                    //     "questionWithMultipleAnswers": false,
                    //     "CRM": [{"q":"נא להשלים את פרטי הלווה הנוסף. שם לווה", "order":41},
                    //             {"q":"טלפון לווה", "order":43},
                    //             {"q":"תאריך לידה לווה", "order":45},
                    //             {"q":"תז. לווה", "order":42},
                    //             {"q":"קרבה הלווה", "order":44}],
                    //     "answer": {
                    //         "nextStep": "4",
                    //         "nextQuestion": "29",
                    //         "answer-data":[
                    //                 {   borrowerId:"1",
                    //                     "fields": [
                    //                         {
                    //                             "answerText":"נא להשלים את פרטי הלווה הנוסף. שם לווה",
                    //                             "answerKey": "borrowerFullName",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"טלפון לווה",
                    //                             "answerKey": "borrowerPhoneNumber",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"תאריך לידה לווה",
                    //                             "answerKey": "borrowerBirthDate",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"תז. לווה",
                    //                             "answerKey": "borrowerIdNumber",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"קרבה הלווה",
                    //                             "answerKey": "borrowerProximity",
                    //                             "answerValue": ""
                    //                         }
                    //                     ]
                    //                 },
                    //                 {   borrowerId:"2",
                    //                     "fields": [
                    //                         {
                    //                             "answerText":"נא להשלים את פרטי הלווה הנוסף. שם לווה",
                    //                             "answerKey": "borrowerFullName",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"טלפון לווה",
                    //                             "answerKey": "borrowerPhoneNumber",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"תאריך לידה לווה",
                    //                             "answerKey": "borrowerBirthDate",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"תז. לווה",
                    //                             "answerKey": "borrowerIdNumber",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"קרבה הלווה",
                    //                             "answerKey": "borrowerProximity",
                    //                             "answerValue": ""
                    //                         }
                    //                     ]
                    //                 },
                    //                 {   borrowerId:"3",
                    //                     "fields": [
                    //                         {
                    //                             "answerText":"נא להשלים את פרטי הלווה הנוסף. שם לווה",
                    //                             "answerKey": "borrowerFullName",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"טלפון לווה",
                    //                             "answerKey": "borrowerPhoneNumber",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"תאריך לידה לווה",
                    //                             "answerKey": "borrowerBirthDate",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"תז. לווה",
                    //                             "answerKey": "borrowerIdNumber",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"קרבה הלווה",
                    //                             "answerKey": "borrowerProximity",
                    //                             "answerValue": ""
                    //                         }
                    //                     ]
                    //                 },
                    //                 {   borrowerId:"4",
                    //                     "fields": [
                    //                         {
                    //                             "answerText":"נא להשלים את פרטי הלווה הנוסף. שם לווה",
                    //                             "answerKey": "borrowerFullName",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"טלפון לווה",
                    //                             "answerKey": "borrowerPhoneNumber",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"תאריך לידה לווה",
                    //                             "answerKey": "borrowerBirthDate",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"תז. לווה",
                    //                             "answerKey": "borrowerIdNumber",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"קרבה הלווה",
                    //                             "answerKey": "borrowerProximity",
                    //                             "answerValue": ""
                    //                         }
                    //                     ]
                    //                 },
                    //                 {   borrowerId:"5",
                    //                     "fields": [
                    //                         {
                    //                             "answerText":"נא להשלים את פרטי הלווה הנוסף. שם לווה",
                    //                             "answerKey": "borrowerFullName",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"טלפון לווה",
                    //                             "answerKey": "borrowerPhoneNumber",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"תאריך לידה לווה",
                    //                             "answerKey": "borrowerBirthDate",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"תז. לווה",
                    //                             "answerKey": "borrowerIdNumber",
                    //                             "answerValue": ""
                    //                         },
                    //                         {
                    //                             "answerText":"קרבה הלווה",
                    //                             "answerKey": "borrowerProximity",
                    //                             "answerValue": ""
                    //                         }
                    //                     ]
                    //                 }
                    //         ]

                    //     }
                    // },
                    {
                        "questionId": "29",
                        "questionName": "additionalBorrowersDetails2",
                        "questionType": "Borrower",
                        "previousStep": "4",
                        "previousQuestion": "23",
                        "previousAnswer": "1",
                        "questionText": "נא להשלים את פרטי הלווים הנוספים",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "לווה ראשי נא להשלים את פרטי הלווים הנוספים", "order": 48 },
                        { "q": "כתובת המגורים לווים נוספים", "order": 47 },
                        { "q": "לווים נוספים כמה ילדים יש בבית מתחת לגיל 18?", "order": 49 },
                        { "q": "מצב משפחתי של לווים נוספים", "order": 46 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "33-1",
                            "answer-data": [
                                {
                                    borrowerId: "1",
                                    "fields": [
                                        {
                                            "answerText": "שם מלא לווה",
                                            "answerKey": "borrowerFullName",
                                            "answerValue": ""
                                        },
                                        // {
                                        //     "answerText":"כתובת לווה",
                                        //     "answerKey": "borrowerAddress",
                                        //     "answerValue": ""
                                        // },
                                        {
                                            "answerText": "מספר ילדים לווה",
                                            "answerKey": "borrowerChildrenNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "מצב משפחתי של הלווה",
                                            "answerKey": "borrowerMaritalStatus",
                                            "answerValue": ""
                                        }
                                    ]
                                },
                                {
                                    borrowerId: "2",
                                    "fields": [
                                        {
                                            "answerText": "שם מלא לווה",
                                            "answerKey": "borrowerFullName",
                                            "answerValue": ""
                                        },
                                        // {
                                        //     "answerText":"כתובת לווה",
                                        //     "answerKey": "borrowerAddress",
                                        //     "answerValue": ""
                                        // },
                                        {
                                            "answerText": "מספר ילדים לווה",
                                            "answerKey": "borrowerChildrenNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "מצב משפחתי של הלווה",
                                            "answerKey": "borrowerMaritalStatus",
                                            "answerValue": ""
                                        }
                                    ]
                                },
                                {
                                    borrowerId: "3",
                                    "fields": [
                                        {
                                            "answerText": "שם מלא לווה",
                                            "answerKey": "borrowerFullName",
                                            "answerValue": ""
                                        },
                                        // {
                                        //     "answerText":"כתובת לווה",
                                        //     "answerKey": "borrowerAddress",
                                        //     "answerValue": ""
                                        // },
                                        {
                                            "answerText": "מספר ילדים לווה",
                                            "answerKey": "borrowerChildrenNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "מצב משפחתי של הלווה",
                                            "answerKey": "borrowerMaritalStatus",
                                            "answerValue": ""
                                        }
                                    ]
                                },
                                {
                                    borrowerId: "4",
                                    "fields": [
                                        {
                                            "answerText": "שם מלא לווה",
                                            "answerKey": "borrowerFullName",
                                            "answerValue": ""
                                        },
                                        // {
                                        //     "answerText":"כתובת לווה",
                                        //     "answerKey": "borrowerAddress",
                                        //     "answerValue": ""
                                        // },
                                        {
                                            "answerText": "מספר ילדים לווה",
                                            "answerKey": "borrowerChildrenNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "מצב משפחתי של הלווה",
                                            "answerKey": "borrowerMaritalStatus",
                                            "answerValue": ""
                                        }
                                    ]
                                },
                                {
                                    borrowerId: "5",
                                    "fields": [
                                        {
                                            "answerText": "שם מלא לווה",
                                            "answerKey": "borrowerFullName",
                                            "answerValue": ""
                                        },
                                        // {
                                        //     "answerText":"כתובת לווה",
                                        //     "answerKey": "borrowerAddress",
                                        //     "answerValue": ""
                                        // },
                                        {
                                            "answerText": "מספר ילדים לווה",
                                            "answerKey": "borrowerChildrenNumber",
                                            "answerValue": ""
                                        },
                                        {
                                            "answerText": "מצב משפחתי של הלווה",
                                            "answerKey": "borrowerMaritalStatus",
                                            "answerValue": ""
                                        }
                                    ]
                                },
                            ]
                        }
                    },

                    // borrower 1
                    {
                        "questionId": "33-1",
                        "questionName": "additionalBorrowersDetails3",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "29",
                        "previousAnswer": "",
                        "questionText": "מהי ההשכלה של לווה 1? מהו המקצוע של לווה 1?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מהי ההשכלה של לווה 1?", "order": 50 }, { "q": "מהו המקצוע של לווה 1?", "order": 51 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "35-1",
                            "fields": [
                                {
                                    "answerText": "השכלה",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מקצוע",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "35-1",
                        "questionName": "statusEmployment",
                        "isJunction": true,
                        "previousStep": "4",
                        "previousQuestion": "33-1",
                        "previousAnswer": "1",
                        "questionText": "מהו המצב התעסוקתי של לווה 1?",
                        "questionWithMultipleAnswers": true,
                        "questionType": "YesNo",
                        "CRMOrder": 52,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "employee":
                            {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "36a-1",
                                "answerText": "שכיר"
                            },
                            "independent":
                            {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "35.1-1",
                                "answerText": "עצמאי"
                            },
                            "unemployed":
                            {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "48-1",
                                "answerText": "לא עובד"
                            },
                            "employeeAndIndependent":
                            {
                                "answerId": "4",
                                "nextStep": "4",
                                "nextQuestion": "42-1",
                                "answerText": "גם עצמאי וגם שכיר"
                            }
                        }
                    },
                    {
                        "questionId": "35.1-1",
                        "questionName": "brwYeshuvAvodaForEmployee-1",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "35-1",
                        "previousAnswer": "",
                        "questionText": "באיזה יישוב עובד כעצמאי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "באיזה יישוב עובד כעצמאי?", "order": 14 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "36b-1",
                            "fields": [
                                {
                                    "answerText": "באיזו עיר ",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "36a-1",
                        "questionName": "startOfWorkDate",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "4",
                        "previousQuestion": "35-1",
                        "previousAnswer": "",
                        "questionText": "תתאריך תחילת העבודה של לווה 1?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 53,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "under1": {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "37a-1",
                                "answerText": "מתחת לשנה"
                            },
                            "over1": {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "38-1",
                                "answerText": "יותר משנה"
                            },
                            "over3": {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "38-1",
                                "answerText": "יותר מ3 שנים"
                            }
                        }
                    },
                    {
                        "questionId": "36b-1",
                        "questionName": "startOfWorkDate",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "4",
                        "previousQuestion": "35-1",
                        "previousAnswer": "",
                        "questionText": "תתאריך תחילת העבודה של לווה 1?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 53,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "under1": {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "37b-1",
                                "answerText": "מתחת לשנה"
                            },
                            "over1": {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "41-1",
                                "answerText": "יותר משנה"
                            },
                            "over3": {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "41-1",
                                "answerText": "יותר מ3 שנים"
                            }
                        }
                    },
                    {
                        "questionId": "37a-1",
                        "questionName": "howLongWorkedPreviousWork",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "36a-1",
                        "previousAnswer": "1",
                        "questionText": "כמה זמן עבד לווה 1  במקום העבודה הקודם שלו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "לווה 1 ,שנות ותק במקום העבודה הנוכחי/שנות ותק כעצמאי", "order": 54 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "38-1",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "37b-1",
                        "questionName": "howLongWorkedPreviousWork",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "36b-1",
                        "previousAnswer": "1",
                        "questionText": "כמה זמן עבד לווה 1  במקום העבודה הקודם שלו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "לווה 1 ,שנות ותק במקום העבודה הנוכחי/שנות ותק כעצמאי", "order": 54 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "41-1",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },

                    {
                        "questionId": "38-1",
                        "questionName": "whatsYourMonthlyIncome",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "37-1",
                        "previousAnswer": "",
                        "questionText": "מה סכום ההכנסה החודשית של לווה 1?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה סכום ההכנסה החודשית של לווה 1?", "order": 55 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "39-1",
                            "fields": [
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "39-1",
                        "questionName": "nameAndFieldOccupation",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "38-1",
                        "previousAnswer": "1",
                        "questionText": "מי ההחברה המעסיקה את לווה 1? מה סיווג הארגון בו אתה עובד ומה מקום העבודה ?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מי ההחברה המעסיקה את לווה 1?", "order": 56 }, { "q": "מקום עבודה ללוה 1?", "order": 57.5 }, { "q": "מה סיווג הארגון בו אתה עובד לווה 1?", "order": 57.6 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-1",
                            "fields": [
                                {
                                    "answerText": "הקלד שם הארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סיווג ארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מקום עבודה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "41-1",
                        "questionName": "annualIncome",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "37-1",
                        "previousAnswer": "",
                        "questionText": "מה ההכנסה השנתית נטו של לווה 1?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה ההכנסה השנתית נטו של לווה 1?", "order": 58 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-1",
                            "fields": [
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "42-1",
                        "questionName": "startedDate&MonthlyIncomeAsEmployee",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "35-1",
                        "previousAnswer": "4",
                        "questionText": "תחילת העבודה לווה 1  כשכיר מהי  ההכנסה החודשית נטו כשכיר?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "תחילת העבודה של לווה 1  כשכיר.", "order": 59 }, { "q": "מהי ההכנסה החודשית נטו כשכיר לווה 1?", "order": 60 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "44-1",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "44-1",
                        "questionName": "nameAndFieldOccupationForEmployeeAndIndependent",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "43-1",
                        "previousAnswer": "1",
                        "questionText": "מי ההחברה המעסיקה את לווה 1? באיזה תחום פועלת החברה ? מה סיווג הארגון בו אתה עובד ?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מי ההחברה המעסיקה את לווה 1?", "order": 61 }, { "q": "באיזה תחום פועלת החברה לווה 1?", "order": 62 }, { "q": "מה סיווג הארגון בו אתה עובד לווה 1?", "order": 62.5 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "46-1",
                            "fields": [
                                {
                                    "answerText": "הקלד שם הארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סיווג ארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מקום עבודה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "46-1",
                        "questionName": "startedDate&AnnualIncomeAsIndependent",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "44-1",
                        "previousAnswer": "1",
                        "questionText": "תאריך תחילת עבודה כעצמאי + סכום ההכנסה השנתית נטו כעצמאי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "תאריך תחילת עבודה כעצמאי", "order": 63 }, { "q": "סכום ההכנסה השנתית נטו כעצמאי", "order": 64 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-1",
                            "fields": [
                                {
                                    "answerText": "בחר תאריך",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "48-1",
                        "questionName": "additionalIncomeType&AmountMonthly",
                        "questionType": "InputArray",
                        "isLastQuestionForBorrower": true,
                        "previousStep": "4",
                        "previousQuestion": "",
                        "previousAnswer": "",
                        "questionText": "האם יש ל-לווה 1 הכנסות נוספות? מה ההכנסה החודשית נטו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "האם יש ל לווה 1 הכנסות נוספות? מה ההכנסה החודשית נטו?", "order": 65 },
                        { "q": "מה ההכנסה החודשית נטו של לווה 1?", "order": 66 },
                        { "q": "פירוט ההכנסה לווה 1?", "order": 85 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "33-2",
                            "fieldsArray": [
                                [{
                                    "answerText": "סוג הכנסה",
                                    "answerKey": "type",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "סכום",
                                    "answerKey": "amount",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "פירוט ההכנסה",
                                    "answerKey": "source",
                                    "answerValue": ""
                                }]
                            ]
                        }
                    },

                    // borrower 2					
                    {
                        "questionId": "33-2",
                        "questionName": "additionalBorrowersDetails3",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "29",
                        "previousAnswer": "",
                        "questionText": "מהי ההשכלה של לווה 2? מהו המקצוע של לווה 2?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מהי ההשכלה של לווה 2?", "order": 50 }, { "q": "מהו המקצוע של לווה 2?", "order": 51 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "35-2",
                            "fields": [
                                {
                                    "answerText": "בחר",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מקצוע",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "35-2",
                        "questionName": "statusEmployment",
                        "isJunction": true,
                        "previousStep": "4",
                        "previousQuestion": "33-2",
                        "previousAnswer": "1",
                        "questionText": "מהו המצב התעסוקתי של לווה 2?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 52,
                        "questionType": "YesNo",
                        "selectedAnswer": "",
                        "answersOptions": {
                            "employee":
                            {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "36a-2",
                                "answerText": "שכיר"
                            },
                            "independent":
                            {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "35.1-2",
                                "answerText": "עצמאי"
                            },
                            "unemployed":
                            {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "48-2",
                                "answerText": "לא עובד"
                            },
                            "employeeAndIndependent":
                            {
                                "answerId": "4",
                                "nextStep": "4",
                                "nextQuestion": "42-2",
                                "answerText": "גם עצמאי וגם שכיר"
                            }
                        }
                    },
                    {
                        "questionId": "35.1-2",
                        "questionName": "brwYeshuvAvodaForEmployee-2",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "35-2",
                        "previousAnswer": "",
                        "questionText": "באיזה יישוב עובד כעצמאי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "באיזה יישוב עובד כעצמאי?", "order": 14 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "36b-2",
                            "fields": [
                                {
                                    "answerText": "באיזו עיר ",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "36a-2",
                        "questionName": "startOfWorkDate",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "4",
                        "previousQuestion": "35-2",
                        "previousAnswer": "",
                        "questionText": "תתאריך תחילת העבודה של לווה 2?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 53,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "under1": {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "37a-2",
                                "answerText": "מתחת לשנה"
                            },
                            "over1": {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "38-2",
                                "answerText": "יותר משנה"
                            },
                            "over3": {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "38-2",
                                "answerText": "יותר מ3 שנים"
                            }
                        }
                    },
                    {
                        "questionId": "36b-2",
                        "questionName": "startOfWorkDate",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "4",
                        "previousQuestion": "35-2",
                        "previousAnswer": "",
                        "questionText": "תתאריך תחילת העבודה של לווה 2?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 53,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "under1": {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "37b-2",
                                "answerText": "מתחת לשנה"
                            },
                            "over1": {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "41-2",
                                "answerText": "יותר משנה"
                            },
                            "over3": {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "41-2",
                                "answerText": "יותר מ3 שנים"
                            }
                        }
                    },
                    {
                        "questionId": "37a-2",
                        "questionName": "howLongWorkedPreviousWork",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "36a-2",
                        "previousAnswer": "1",
                        "questionText": "כמה זמן עבד לווה 2  במקום העבודה הקודם שלו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "לווה 2 ,שנות ותק במקום העבודה הנוכחי/שנות ותק כעצמאי", "order": 54 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "38-2",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "37b-2",
                        "questionName": "howLongWorkedPreviousWork",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "36b-2",
                        "previousAnswer": "1",
                        "questionText": "כמה זמן עבד לווה 2  במקום העבודה הקודם שלו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "לווה 2 ,שנות ותק במקום העבודה הנוכחי/שנות ותק כעצמאי", "order": 54 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "41-2",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "38-2",
                        "questionName": "whatsYourMonthlyIncome",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "37-2",
                        "previousAnswer": "",
                        "questionText": "מה סכום ההכנסה החודשית של לווה 2?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה סכום ההכנסה החודשית של לווה 2?", "order": 55 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "39-2",
                            "fields": [
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "39-2",
                        "questionName": "nameAndFieldOccupation",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "38-2",
                        "previousAnswer": "1",
                        "questionText": " מי ההחברה המעסיקה את לווה 2? מה סיווג הארגון בו אתה עובד ? ומה מקום העבודה",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מי ההחברה המעסיקה את לווה 2?", "order": 56 }, { "q": "מה סיווג הארגון בו אתה עובד לווה 2?", "order": 57.5 }, { "q": "מה מקום העבודה?", "order": 57.6 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-2",
                            "fields": [
                                {
                                    "answerText": "הקלד שם הארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סיווג ארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מקום עבודה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "41-2",
                        "questionName": "annualIncome",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "37-2",
                        "previousAnswer": "",
                        "questionText": "מה ההכנסה השנתית נטו של לווה 2?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה ההכנסה השנתית נטו של לווה 2?", "order": 58 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-2",
                            "fields": [
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "42-2",
                        "questionName": "startedDate&MonthlyIncomeAsEmployee",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "35-2",
                        "previousAnswer": "4",
                        "questionText": "תחילת העבודה לווה 2  כשכיר מהי ההכנסה החודשית נטו כשכיר?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "תחילת העבודה של לווה 2  כשכיר.", "order": 59 }, { "q": "מהי ההכנסה החודשית נטו כשכיר לווה 2?", "order": 60 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "44-2",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "44-2",
                        "questionName": "nameAndFieldOccupationForEmployeeAndIndependent",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "43-2",
                        "previousAnswer": "1",
                        "questionText": "מי ההחברה המעסיקה את לווה 2? מה סיווג הארגון בו אתה עובד ?באיזה תחום פועלת החברה?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מי ההחברה המעסיקה את לווה 2?", "order": 61 }, { "q": "באיזה תחום פועלת החברה לווה 2?", "order": 62 }, { "q": "מה סיווג הארגון בו אתה עובד לווה 2?", "order": 62.5 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "46-2",
                            "fields": [
                                {
                                    "answerText": "הקלד שם הארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד תחום העיסוק",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סיווג ארגון",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "46-2",
                        "questionName": "startedDate&AnnualIncomeAsIndependent",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "44-2",
                        "previousAnswer": "1",
                        "questionText": "תאריך תחילת עבודה כעצמאי + סכום ההכנסה השנתית נטו כעצמאי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "תאריך תחילת עבודה כעצמאי", "order": 63 }, { "q": "סכום ההכנסה השנתית נטו כעצמאי", "order": 64 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-2",
                            "fields": [
                                {
                                    "answerText": "בחר תאריך",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "48-2",
                        "questionName": "additionalIncomeType&AmountMonthly",
                        "isLastQuestionForBorrower": true,
                        "questionType": "InputArray",
                        "previousStep": "4",
                        "previousQuestion": "35-2",
                        "previousAnswer": "",
                        "questionText": "האם יש ל-לווה 2 הכנסות נוספות? מה ההכנסה החודשית נטו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "האם יש ל לווה 2 הכנסות נוספות? מה ההכנסה החודשית נטו?", "order": 65 },
                        { "q": "מה ההכנסה החודשית נטו של לווה 2?", "order": 66 },
                        { "q": "פירוט ההכנסה לווה 2?", "order": 86 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "33-3",
                            "fieldsArray": [
                                [{
                                    "answerText": " סוג הכנסה",
                                    "answerKey": "type",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": " סכום",
                                    "answerKey": "amount",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "פירוט ההכנסה",
                                    "answerKey": "source",
                                    "answerValue": ""
                                }]
                            ]
                        }
                    },

                    // borrower 3					
                    {
                        "questionId": "33-3",
                        "questionName": "additionalBorrowersDetails3",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "29",
                        "previousAnswer": "",
                        "questionText": "מהי ההשכלה של לווה 3? מהו המקצוע של לווה 3?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מהי ההשכלה של לווה 3?", "order": 50 }, { "q": "מהו המקצוע של לווה 3?", "order": 51 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "35-3",
                            "fields": [
                                {
                                    "answerText": "השכלה",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מקצוע",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "35-3",
                        "questionName": "statusEmployment",
                        "isJunction": true,
                        "previousStep": "4",
                        "previousQuestion": "33-3",
                        "previousAnswer": "1",
                        "questionText": "מהו המצב התעסוקתי של לווה 3?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 52,
                        "questionType": "YesNo",
                        "selectedAnswer": "",
                        "answersOptions": {
                            "employee":
                            {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "36a-3",
                                "answerText": "שכיר"
                            },
                            "independent":
                            {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "35.1-3",
                                "answerText": "עצמאי"
                            },
                            "unemployed":
                            {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "48-3",
                                "answerText": "לא עובד"
                            },
                            "employeeAndIndependent":
                            {
                                "answerId": "4",
                                "nextStep": "4",
                                "nextQuestion": "42-3",
                                "answerText": "גם עצמאי וגם שכיר"
                            }
                        }
                    },
                    {
                        "questionId": "35.1-3",
                        "questionName": "brwYeshuvAvodaForEmployee-3",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "35-3",
                        "previousAnswer": "",
                        "questionText": "באיזה יישוב עובד כעצמאי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "באיזה יישוב עובד כעצמאי?", "order": 14 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "36b-3",
                            "fields": [
                                {
                                    "answerText": "באיזו עיר ",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },

                    {
                        "questionId": "36a-3",
                        "questionName": "startOfWorkDate",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "4",
                        "previousQuestion": "35-3",
                        "previousAnswer": "",
                        "questionText": "תתאריך תחילת העבודה של לווה 3?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 53,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "under1": {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "37a-3",
                                "answerText": "מתחת לשנה"
                            },
                            "over1": {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "38-3",
                                "answerText": "יותר משנה"
                            },
                            "over3": {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "38-3",
                                "answerText": "יותר מ3 שנים"
                            }
                        }
                    },
                    {
                        "questionId": "36b-3",
                        "questionName": "startOfWorkDate",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "4",
                        "previousQuestion": "35-3",
                        "previousAnswer": "",
                        "questionText": "תתאריך תחילת העבודה של לווה 3?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 53,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "under1": {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "37b-3",
                                "answerText": "מתחת לשנה"
                            },
                            "over1": {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "41-3",
                                "answerText": "יותר משנה"
                            },
                            "over3": {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "41-3",
                                "answerText": "יותר מ3 שנים"
                            }
                        }
                    },
                    {
                        "questionId": "37a-3",
                        "questionName": "howLongWorkedPreviousWork",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "36a-3",
                        "previousAnswer": "1",
                        "questionText": "כמה זמן עבד לווה 3  במקום העבודה הקודם שלו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "לווה 3 ,שנות ותק במקום העבודה הנוכחי/שנות ותק כעצמאי", "order": 54 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "38-3",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "37b-3",
                        "questionName": "howLongWorkedPreviousWork",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "36b-3",
                        "previousAnswer": "1",
                        "questionText": "כמה זמן עבד לווה 3  במקום העבודה הקודם שלו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "לווה 3 ,שנות ותק במקום העבודה הנוכחי/שנות ותק כעצמאי", "order": 54 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "41-3",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },


                    {
                        "questionId": "38-3",
                        "questionName": "whatsYourMonthlyIncome",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "37-3",
                        "previousAnswer": "",
                        "questionText": "מה סכום ההכנסה החודשית של לווה 3?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה סכום ההכנסה החודשית של לווה 3?", "order": 55 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "39-3",
                            "fields": [
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "39-3",
                        "questionName": "nameAndFieldOccupation",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "38-3",
                        "previousAnswer": "1",
                        "questionText": "מי ההחברה המעסיקה את לווה 3? מה סיווג הארגון בו אתה עובד ? ומקום עבודה",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מי ההחברה המעסיקה את לווה 3?", "order": 56 }, { "q":"מקום עבודה?", "order": 57.6 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-3",
                            "fields": [
                                {
                                    "answerText": "הקלד שם הארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סיווג ארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מקום עבודה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "41-3",
                        "questionName": "annualIncome",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "37-3",
                        "previousAnswer": "",
                        "questionText": "מה ההכנסה השנתית נטו של לווה 3?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה ההכנסה השנתית נטו של לווה 3?", "order": 58 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-3",
                            "fields": [
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "42-3",
                        "questionName": "startedDate&MonthlyIncomeAsEmployee",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "35-3",
                        "previousAnswer": "4",
                        "questionText": "תחילת העבודה לווה 3  כשכיר מהי ההכנסה החודשית נטו כשכיר?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "תחילת העבודה של לווה 3  כשכיר.", "order": 59 }, { "q": "מהי ההכנסה החודשית נטו כשכיר לווה 3?", "order": 60 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "44-3",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "44-3",
                        "questionName": "nameAndFieldOccupationForEmployeeAndIndependent",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "43-3",
                        "previousAnswer": "1",
                        "questionText": "מי ההחברה המעסיקה את לווה 3? מה סיווג הארגון בו אתה עובד ?באיזה תחום פועלת החברה?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מי ההחברה המעסיקה את לווה 3?", "order": 61 }, { "q": "באיזה תחום פועלת החברה לווה 3?", "order": 62 }, { "q": "מה סיווג הארגון בו אתה עובד לווה 3?", "order": 62.5 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "46-3",
                            "fields": [
                                {
                                    "answerText": "הקלד שם הארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד תחום העיסוק",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סיווג ארגון",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "46-3",
                        "questionName": "startedDate&AnnualIncomeAsIndependent",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "44-3",
                        "previousAnswer": "1",
                        "questionText": "תאריך תחילת עבודה כעצמאי + סכום ההכנסה השנתית נטו כעצמאי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "תאריך תחילת עבודה כעצמאי", "order": 63 }, { "q": "סכום ההכנסה השנתית נטו כעצמאי", "order": 64 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-3",
                            "fields": [
                                {
                                    "answerText": "בחר תאריך",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "48-3",
                        "questionName": "additionalIncomeType&AmountMonthly",
                        "isLastQuestionForBorrower": true,
                        "questionType": "InputArray",
                        "previousStep": "4",
                        "previousQuestion": "35-3",
                        "previousAnswer": "",
                        "questionText": "האם יש ל-לווה 3 הכנסות נוספות? מה ההכנסה החודשית נטו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "האם יש ל לווה 3 הכנסות נוספות? מה ההכנסה החודשית נטו?", "order": 65 },
                        { "q": "מה ההכנסה החודשית נטו של לווה 3?", "order": 66 },
                        { "q": "פירוט ההכנסה לווה 3?", "order": 87 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "33-4",
                            "fieldsArray": [
                                [{
                                    "answerText": " סוג הכנסה",
                                    "answerKey": "type",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": " סכום",
                                    "answerKey": "amount",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "פירוט ההכנסה",
                                    "answerKey": "source",
                                    "answerValue": ""
                                }]
                            ]
                        }
                    },
                    // borrower 4
                    {
                        "questionId": "33-4",
                        "questionName": "additionalBorrowersDetails3",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "29",
                        "previousAnswer": "",
                        "questionText": "מהי ההשכלה של לווה 4? מהו המקצוע של לווה 4?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מהי ההשכלה של לווה 4?", "order": 50 }, { "q": "מהו המקצוע של לווה 4?", "order": 51 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "35-4",
                            "fields": [
                                {
                                    "answerText": "השכלה",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מקצוע",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "35-4",
                        "questionName": "statusEmployment",
                        "isJunction": true,
                        "previousStep": "4",
                        "previousQuestion": "33-4",
                        "previousAnswer": "1",
                        "questionText": "מהו המצב התעסוקתי של לווה 4?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 52,
                        "questionType": "YesNo",
                        "selectedAnswer": "",
                        "answersOptions": {
                            "employee":
                            {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "36a-4",
                                "answerText": "שכיר"
                            },
                            "independent":
                            {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "35.1-4",
                                "answerText": "עצמאי"
                            },
                            "unemployed":
                            {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "48-4",
                                "answerText": "לא עובד"
                            },
                            "employeeAndIndependent":
                            {
                                "answerId": "4",
                                "nextStep": "4",
                                "nextQuestion": "42-4",
                                "answerText": "גם עצמאי וגם שכיר"
                            }
                        }
                    },
                    {
                        "questionId": "35.1-4",
                        "questionName": "brwYeshuvAvodaForEmployee-4",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "35-4",
                        "previousAnswer": "",
                        "questionText": "באיזה יישוב עובד כעצמאי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "באיזה יישוב עובד כעצמאי?", "order": 14 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "36b-4",
                            "fields": [
                                {
                                    "answerText": "באיזו עיר ",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },

                    {
                        "questionId": "36a-4",
                        "questionName": "startOfWorkDate",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "4",
                        "previousQuestion": "35-4",
                        "previousAnswer": "",
                        "questionText": "תתאריך תחילת העבודה של לווה 4?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 53,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "under1": {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "37a-4",
                                "answerText": "מתחת לשנה"
                            },
                            "over1": {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "38-4",
                                "answerText": "יותר משנה"
                            },
                            "over3": {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "38-4",
                                "answerText": "יותר מ3 שנים"
                            }
                        }
                    },
                    {
                        "questionId": "36b-4",
                        "questionName": "startOfWorkDate",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "4",
                        "previousQuestion": "35-4",
                        "previousAnswer": "",
                        "questionText": "תתאריך תחילת העבודה של לווה 4?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 53,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "under1": {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "37b-4",
                                "answerText": "מתחת לשנה"
                            },
                            "over1": {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "41-4",
                                "answerText": "יותר משנה"
                            },
                            "over3": {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "41-4",
                                "answerText": "יותר מ3 שנים"
                            }
                        }
                    },
                    {
                        "questionId": "37a-4",
                        "questionName": "howLongWorkedPreviousWork",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "36a-4",
                        "previousAnswer": "1",
                        "questionText": "כמה זמן עבד לווה 4  במקום העבודה הקודם שלו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "לווה 4 ,שנות ותק במקום העבודה הנוכחי/שנות ותק כעצמאי", "order": 54 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "38-4",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "37b-4",
                        "questionName": "howLongWorkedPreviousWork",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "36b-4",
                        "previousAnswer": "1",
                        "questionText": "כמה זמן עבד לווה 4  במקום העבודה הקודם שלו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "לווה 4 ,שנות ותק במקום העבודה הנוכחי/שנות ותק כעצמאי", "order": 54 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "41-4",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },



                    {
                        "questionId": "38-4",
                        "questionName": "whatsYourMonthlyIncome",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "37-4",
                        "previousAnswer": "",
                        "questionText": "מה סכום ההכנסה החודשית של לווה 4?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה סכום ההכנסה החודשית של לווה 4?", "order": 55 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "39-4",
                            "fields": [
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "39-4",
                        "questionName": "nameAndFieldOccupation",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "38-4",
                        "previousAnswer": "1",
                        "questionText": "מי ההחברה המעסיקה את לווה 4? מה סיווג הארגון בו אתה עובד ?ומקום עבודה",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מי ההחברה המעסיקה את לווה 4?", "order": 56 }, { "q": "מה סיווג הארגון בו אתה עובד לווה 4?", "order": 57.5 },, { "q": "מקום עבודה ?", "order": 57.6 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-4",
                            "fields": [
                                {
                                    "answerText": "הקלד שם הארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סיווג ארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מקום עבודה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "41-4",
                        "questionName": "annualIncome",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "37-4",
                        "previousAnswer": "",
                        "questionText": "מה ההכנסה השנתית נטו של לווה 4?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה ההכנסה השנתית נטו של לווה 4?", "order": 58 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-4",
                            "fields": [
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "42-4",
                        "questionName": "startedDate&MonthlyIncomeAsEmployee",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "35-4",
                        "previousAnswer": "4",
                        "questionText": "תחילת העבודה לווה 4  כשכיר מהי ההכנסה החודשית נטו כשכיר?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "תחילת העבודה של לווה 4  כשכיר.", "order": 59 }, { "q": "מהי ההכנסה החודשית נטו כשכיר ?", "order": 60 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "44-4",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "44-4",
                        "questionName": "nameAndFieldOccupationForEmployeeAndIndependent",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "43-4",
                        "previousAnswer": "1",
                        "questionText": "מי ההחברה המעסיקה את לווה 4? מה סיווג הארגון בו אתה עובד ?באיזה תחום פועלת החברה?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מי ההחברה המעסיקה את לווה 4?", "order": 61 }, { "q": "באיזה תחום פועלת החברה לווה 4?", "order": 62 }, { "q": "מה סיווג הארגון בו אתה עובד לווה 4?", "order": 62.5 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "46-4",
                            "fields": [
                                {
                                    "answerText": "הקלד שם הארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד תחום העיסוק",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סיווג ארגון",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "46-4",
                        "questionName": "startedDate&AnnualIncomeAsIndependent",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "44-4",
                        "previousAnswer": "1",
                        "questionText": "תאריך תחילת עבודה כעצמאי + סכום ההכנסה השנתית נטו כעצמאי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "תאריך תחילת עבודה כעצמאי", "order": 63 }, { "q": "סכום ההכנסה השנתית נטו כעצמאי", "order": 64 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-4",
                            "fields": [
                                {
                                    "answerText": "בחר תאריך",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "48-4",
                        "questionName": "additionalIncomeType&AmountMonthly",
                        "isLastQuestionForBorrower": true,
                        "questionType": "InputArray",
                        "previousStep": "4",
                        "previousQuestion": "",
                        "previousAnswer": "",
                        "questionText": "האם יש ל-לווה 4 הכנסות נוספות? מה ההכנסה החודשית נטו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "האם יש ל לווה 4 הכנסות נוספות? מה ההכנסה החודשית נטו?", "order": 65 },
                        { "q": "מה ההכנסה החודשית נטו של לווה 4?", "order": 66 },
                        { "q": "פירוט ההכנסה לווה 4?", "order": 88 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "33-5",
                            "fieldsArray": [
                                [{
                                    "answerText": " סוג הכנסה",
                                    "answerKey": "type",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": " סכום",
                                    "answerKey": "amount",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "פירוט ההכנסה",
                                    "answerKey": "source",
                                    "answerValue": ""
                                }]
                            ]
                        }
                    },
                    // borrower 5
                    {
                        "questionId": "33-5",
                        "questionName": "additionalBorrowersDetails3",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "29",
                        "previousAnswer": "",
                        "questionText": "מהי ההשכלה של לווה 5? מהו המקצוע של לווה 5?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מהי ההשכלה של לווה 5?", "order": 50 }, { "q": "מהו המקצוע של לווה 5?", "order": 51 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "35-5",
                            "fields": [
                                {
                                    "answerText": "השכלה",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מקצוע",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "35-5",
                        "questionName": "statusEmployment",
                        "isJunction": true,
                        "previousStep": "4",
                        "previousQuestion": "33-5",
                        "previousAnswer": "1",
                        "questionText": "מהו המצב התעסוקתי של לווה 5?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 52,
                        "questionType": "YesNo",
                        "selectedAnswer": "",
                        "answersOptions": {
                            "employee":
                            {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "36a-5",
                                "answerText": "שכיר"
                            },
                            "independent":
                            {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "35.1-5",
                                "answerText": "עצמאי"
                            },
                            "unemployed":
                            {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "48-5",
                                "answerText": "לא עובד"
                            },
                            "employeeAndIndependent":
                            {
                                "answerId": "4",
                                "nextStep": "4",
                                "nextQuestion": "42-5",
                                "answerText": "גם עצמאי וגם שכיר"
                            }
                        }
                    },
                    {
                        "questionId": "35.1-5",
                        "questionName": "brwYeshuvAvodaForEmployee-5",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "35-5",
                        "previousAnswer": "",
                        "questionText": "באיזה יישוב עובד כעצמאי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "באיזה יישוב עובד כעצמאי?", "order": 14 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "36b-5",
                            "fields": [
                                {
                                    "answerText": "באיזו עיר ",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "36a-5",
                        "questionName": "startOfWorkDate",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "CRMOrder": 53,
                        "previousStep": "4",
                        "previousQuestion": "35-5",
                        "previousAnswer": "",
                        "questionText": "תתאריך תחילת העבודה של לווה 5?",
                        "questionWithMultipleAnswers": true,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "under1": {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "37a-5",
                                "answerText": "מתחת לשנה"
                            },
                            "over1": {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "38-5",
                                "answerText": "יותר משנה"
                            },
                            "over3": {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "38-5",
                                "answerText": "יותר מ3 שנים"
                            }
                        }
                    },
                    {
                        "questionId": "36b-5",
                        "questionName": "startOfWorkDate",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "CRMOrder": 53,
                        "previousStep": "4",
                        "previousQuestion": "35-5",
                        "previousAnswer": "",
                        "questionText": "תתאריך תחילת העבודה של לווה 5?",
                        "questionWithMultipleAnswers": true,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "under1": {
                                "answerId": "1",
                                "nextStep": "4",
                                "nextQuestion": "37b-5",
                                "answerText": "מתחת לשנה"
                            },
                            "over1": {
                                "answerId": "2",
                                "nextStep": "4",
                                "nextQuestion": "41-5",
                                "answerText": "יותר משנה"
                            },
                            "over3": {
                                "answerId": "3",
                                "nextStep": "4",
                                "nextQuestion": "41-5",
                                "answerText": "יותר מ3 שנים"
                            }
                        }
                    },
                    {
                        "questionId": "37a-5",
                        "questionName": "howLongWorkedPreviousWork",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "36a-5",
                        "previousAnswer": "1",
                        "questionText": "כמה זמן עבד לווה 5  במקום העבודה הקודם שלו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "לווה 5 ,שנות ותק במקום העבודה הנוכחי/שנות ותק כעצמאי", "order": 54 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "38-5",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "37b-5",
                        "questionName": "howLongWorkedPreviousWork",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "36b-5",
                        "previousAnswer": "1",
                        "questionText": "כמה זמן עבד לווה 5  במקום העבודה הקודם שלו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "לווה 5 ,שנות ותק במקום העבודה הנוכחי/שנות ותק כעצמאי", "order": 54 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "41-5",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },



                    {
                        "questionId": "38-5",
                        "questionName": "whatsYourMonthlyIncome",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "37-5",
                        "previousAnswer": "",
                        "questionText": "מה סכום ההכנסה החודשית של לווה 5?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה סכום ההכנסה החודשית של לווה 5?", "order": 55 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "39-5",
                            "fields": [
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "39-5",
                        "questionName": "nameAndFieldOccupation",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "38-5",
                        "previousAnswer": "1",
                        "questionText": "מי ההחברה המעסיקה את לווה 5? מה סיווג הארגון בו אתה עובד ?ומקום עבודה",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מי ההחברה המעסיקה את לווה 5?", "order": 56 }, { "q": "מה סיווג הארגון בו אתה עובד לווה 5?", "order": 57.5 }, { "q": "מקום עבודה?", "order": 57.6 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-5",
                            "fields": [
                                {
                                    "answerText": "הקלד שם הארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סיווג ארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מקום עבודה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "41-5",
                        "questionName": "annualIncome",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "37-5",
                        "previousAnswer": "",
                        "questionText": "מה ההכנסה השנתית נטו של לווה 5?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה ההכנסה השנתית נטו של לווה 5?", "order": 58 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-5",
                            "fields": [
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "42-5",
                        "questionName": "startedDate&MonthlyIncomeAsEmployee",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "35-5",
                        "previousAnswer": "4",
                        "questionText": "תחילת העבודה לווה 5  כשכיר מהי  ההכנסה החודשית נטו כשכיר?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "תחילת העבודה של לווה 5  כשכיר.", "order": 59 }, { "q": "מהי  ההכנסה החודשית נטו כשכיר?", "order": 60 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "44-5",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "44-5",
                        "questionName": "nameAndFieldOccupationForEmployeeAndIndependent",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "43-5",
                        "previousAnswer": "1",
                        "questionText": "מי ההחברה המעסיקה את לווה 5? מה סיווג הארגון בו אתה עובד ?באיזה תחום פועלת החברה?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מי ההחברה המעסיקה את לווה 5?", "order": 61 }, { "q": "באיזה תחום פועלת החברה לווה 5?", "order": 62 }, { "q": "מה סיווג הארגון בו אתה לווה 5?", "order": 62.5 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "46-5",
                            "fields": [
                                {
                                    "answerText": "הקלד שם הארגון",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד תחום העיסוק",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סיווג ארגון",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "46-5",
                        "questionName": "startedDate&AnnualIncomeAsIndependent",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "44-5",
                        "previousAnswer": "1",
                        "questionText": "תאריך תחילת עבודה כעצמאי + סכום ההכנסה השנתית נטו כעצמאי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "תאריך תחילת עבודה כעצמאי", "order": 63 }, { "q": "סכום ההכנסה השנתית נטו כעצמאי", "order": 64 }],
                        "answer": {
                            "nextStep": "4",
                            "nextQuestion": "48-5",
                            "fields": [
                                {
                                    "answerText": "בחר תאריך",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "48-5",
                        "questionName": "additionalIncomeType&AmountMonthly",
                        "isLastQuestionForBorrower": true,
                        "questionType": "InputArray",
                        "previousStep": "4",
                        "previousQuestion": "",
                        "previousAnswer": "",
                        "questionText": "האם יש ל-לווה 5 הכנסות נוספות? מה ההכנסה החודשית נטו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "האם יש ל לווה 5 הכנסות נוספות? מה ההכנסה החודשית נטו?", "order": 65 },
                        { "q": "מה ההכנסה החודשית נטו של לווה 5?", "order": 66 },
                        { "q": "פירוט ההכנסה לווה 5?", "order": 89 }],
                        "answer": {
                            "nextStep": "5",
                            "nextQuestion": "1",
                            "fieldsArray": [
                                [{
                                    "answerText": " סוג הכנסה",
                                    "answerKey": "type",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": " סכום",
                                    "answerKey": "amount",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "פירוט ההכנסה",
                                    "answerKey": "source",
                                    "answerValue": ""
                                }]
                            ]
                        }
                    }
                ]
            },


            /* ============  step 5 =========== */
            {
                "stepId": "5",
                "stepName": "liabilities",
                "stepTitle": "התחייבויות",
                "waitingTime": "10",
                "numberOfQuestionsMax": "5",
                "questions": [
                    {
                        "questionId": "1",
                        "questionName": "realtyLien",
                        "questionType": "Input",
                        "previousStep": "4",
                        "previousQuestion": "48",
                        "previousAnswer": "1",
                        "questionText": "מה סכום היתרה על שיעבוד הנכס הקיים?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה סכום היתרה על שיעבוד הנכס הקיים?", "order": 67 }],
                        "answer": {
                            "nextStep": "5",
                            "nextQuestion": "2",
                            "fields": [
                                {
                                    "answerText": "סכום השיעבוד",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "2",
                        "questionName": "monthlyRefundAmount",
                        "questionType": "Input",
                        "previousStep": "5",
                        "previousQuestion": "1",
                        "previousAnswer": "1",
                        "questionText": "מה סכום ההחזר החודשי?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה סכום ההחזר החודשי?", "order": 68 }],
                        "answer": {
                            "nextStep": "5",
                            "nextQuestion": "3",
                            "fields": [
                                {
                                    "answerText": "סכום ההחזר החודשי",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "3",
                        "questionName": "whenLiabilitiesEnd",
                        "questionType": "Input",
                        "previousStep": "5",
                        "previousQuestion": "2",
                        "previousAnswer": "1",
                        "questionText": "כמה שנים נותרו לסיום השיעבוד?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "כמה שנים נותרו לסיום השיעבוד?", "order": 69 }],
                        "answer": {
                            "nextStep": "5",
                            "nextQuestion": "4",
                            "fields": [
                                {
                                    "answerText": "DD/MM/YY",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "3.1",
                        "questionName": "amountOfAlimonyPayment",
                        "questionType": "Input",
                        "previousStep": "5",
                        "previousQuestion": "3",
                        "previousAnswer": "1",
                        "questionText": "מה הסכום החודשי בגין תשלום מזונות?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה הסכום החודשי בגין תשלום מזונות?", "order": 69.1 }],
                        "answer": {
                            "nextStep": "5",
                            "nextQuestion": "3.2",
                            "fields": [
                                {
                                    "answerText": "סכום חודשי",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "3.2",
                        "questionName": "endDate",
                        "questionType": "Input",
                        "previousStep": "5",
                        "previousQuestion": "3.1",
                        "previousAnswer": "1",
                        "questionText": "מה תאריך סיום תשלום מזונות?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה תאריך סיום תשלום מזונות?", "order": 69.2 }],
                        "answer": {
                            "nextStep": "5",
                            "nextQuestion": "5",
                            "fields": [
                                {
                                    "answerText": "לידה",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "4",
                        "questionName": "haveYouLiabilities",
                        "isJunction": true,
                        "questionType": "YesNo",
                        "previousStep": "",
                        "previousQuestion": "",
                        "previousAnswer": "",
                        "questionText": "האם יש לך התחייבויות?",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 70,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "nextStep": "5",
                                "nextQuestion": "5",
                                "answerText": "כן"

                            },
                            "NO":
                            {
                                "answerId": "2",
                                "nextStep": "6",
                                "nextQuestion": "5",
                                "answerText": "לא"

                            }

                        }
                    },
                    {
                        "questionId": "5",
                        "questionName": "whichLiabilities",
                        "questionType": "InputArray",
                        "previousStep": "5",
                        "previousQuestion": "4",
                        "previousAnswer": "",
                        "questionText": "אילו התחייבויות יש לך?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "אילו ההתחייבויות הכספיות יש לך? יתרת ההתחיבויות, סכום החזר חודשי, תאריך סיום התחייבויות", "order": 71 },
                        { "q": "יתרת ההתחייבויות", "order": 72 },
                        { "q": "סכום החזר חודשי", "order": 73 },
                        { "q": "תאריך סיום התחייבויות", "order": 74 }],
                        "answer": {
                            "nextStep": "6",
                            "nextQuestion": "5",
                            "fieldsArray": [
                                [{
                                    "answerText": "סוג התייחבות",
                                    "answerKey": "liabilityType",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מה סכום היתרה?",
                                    "answerKey": "liabilityBalance",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מה סכום ההחזר החודשי?",
                                    "answerKey": "liabilityMonthlyRefund",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "מה תאריך סיום ההתחייבויות?",
                                    "answerKey": "liabilityEndDate",
                                    "answerValue": ""
                                }]
                            ]
                        }
                    }
                ]
            },


            /* ============  step 6 =========== */
            {
                "stepId": "6",
                "stepName": "financing-sources",
                "stepTitle": "מקורות מימון",
                "waitingTime": "10",
                "numberOfQuestionsMax": "2",
                "questions": [
                    {
                        "questionId": "1",
                        "questionName": "financing-sources-q1",
                        "questionType": "InputArray",
                        "previousStep": "5",
                        "previousQuestion": "5",
                        "previousAnswer": "1",
                        "questionText": "מה מקור  ההון העצמי?*",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה מקור ההון העצמי שלך?", "order": 75 },
                        { "q": "מה הסכום העומד לרשותך ממקור זה?", "order": 76 },
                        { "q": "פירוט מקור ההון העצמי", "order": 90 }],
                        "answer": {
                            "nextStep": "6",
                            "nextQuestion": "5",
                            "fieldsArray": [
                                [{
                                    "answerText": "מקור ההון העצמי",
                                    "answerKey": "type",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "סכום ההון העצמי",
                                    "answerKey": "amount",
                                    "answerValue": ""
                                },
                                {
                                    "answerText": "פירוט מקור ההון העצמי",
                                    "answerKey": "source",
                                    "answerValue": ""
                                }]
                            ]
                        }
                    },
                    { // step=6, q=5
                        "questionId": "5",
                        "questionName": "mortgage-monthly-refund",
                        "questionType": "Input",
                        "previousStep": "6",
                        "previousQuestion": "1",
                        "previousAnswer": "1",
                        "questionText": "מה גובה ההחזר הרצוי על המשכנתא?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "מה גובה ההחזר הרצוי על המשכנתא?", "order": 79 }],
                        "answer": {
                            "nextStep": "7",
                            "nextQuestion": "1",
                            "isLastQuestion": true,
                            "fields": [
                                {
                                    "answerText": "הקלד סכום",
                                    "answerValue": ""
                                }
                            ]
                        }
                    }
                ]
            },
            /* ============  step 7 =========== */
            {
                "stepId": "7",
                "stepName": "summarize",
                "stepTitle": "סיכום",
                "numberOfQuestionsMax": "1",
                "questions": [
                    {
                        "questionId": "1",
                        "questionName": "what else",
                        "questionType": "Input",
                        "previousStep": "6",
                        "previousQuestion": "5",
                        "previousAnswer": "1",
                        "questionText": "יש לך עוד משהו לספר לנו?",
                        "questionWithMultipleAnswers": false,
                        "CRM": [{ "q": "יש לך עוד משהו לספר לנו?", "order": 80 }],
                        "answer": {
                            "nextStep": "",
                            "nextQuestion": "",
                            "fields": [
                                {
                                    "answerText": "יש לך עוד משהו לספר לנו?",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "2",
                        "questionName": "marketing",
                        "questionType": "YesNo",
                        "previousStep": "6",
                        "previousQuestion": "5",
                        "previousAnswer": "1",
                        "questionText": "מסכים למידע שיווקי?",
                        "questionWithMultipleAnswers": true,
                        "CRM": [{ "q": "מסכים למידע שיווקי?", "order": 94 }],
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "answerText": "כן"

                            },
                            "NO":
                            {
                                "answerId": "2",
                                "answerText": "לא"
                            }
                        }
                    },
                    {
                        "questionId": "3",
                        "questionName": "continueBranch",
                        "isJunction": false,
                        "questionType": "Input",
                        "previousStep": "6",
                        "previousQuestion": "5",
                        "previousAnswer": "",
                        "questionText": "באיזה סניף תרצה להתקדם?",
                        "questionWithMultipleAnswers": false,
                        "CRMOrder": 95,
                        "answer": {
                            "nextStep": "",
                            "nextQuestion": "",
                            "fields": [
                                {
                                    "answerText": "לאיזה סניף תרצה להגיע בכדי להתקדם",
                                    "answerValue": ""
                                }
                            ]
                        }
                    },
                    {
                        "questionId": "4",
                        "isJunction": true,
                        "questionName": "haveOneYet",
                        "questionType": "YesNo",
                        "previousStep": "3",
                        "previousQuestion": "",
                        "previousAnswer": "1",
                        "questionText": "אופן קבלת אישור עקרוני",
                        "questionWithMultipleAnswers": true,
                        "CRMOrder": 10,
                        "selectedAnswer": "",
                        "answersOptions": {
                            "YES":
                            {
                                "answerId": "1",
                                "nextStep": "",
                                "nextQuestion": "",
                                "answerText": "אפליקצייה"

                            },
                            "NO":
                            {
                                "answerId": "2",
                                "nextStep": "",
                                "nextQuestion": "",
                                "answerText": "מייל"

                            }
                        }
                    },

                ]
            }
        ]
    }
}


// WEBPACK FOOTER //
// ./src/data.ts